export default __webpack_public_path__ + "static/media/top-guild-bg_1.e347d446.png";